export class Counter {

    constructor ( target = '.js-counter', options = {} ) {

        this.options = {
            target,
            duration: 2000,
            observer: {
                root: document.querySelector('body'),
                rootMargin: '0px',
                threshold: 0.01
            },
            ...options
        }
        this.counterObserver = new IntersectionObserver((entries, observer) => {
            this.load(entries, this)
        });
    }

    init () {
        this.$counters = Array.from( document.querySelectorAll( this.options.target ) )

        this.$counters.forEach( $counter => {
            this.counterObserver.observe($counter);
        } )
    }

    increment ( $counter, value, current, duration ) {
        $counter.innerText = ++current;
        const delay = duration - (this.options.duration * Math.sin(Math.pow(( value - current ) / value, 3)) );
        duration = duration - delay;

        setTimeout( () => {
            if ( current < value ) {
                this.increment( $counter, value, current, duration )
            }
        }, delay )
    }

    decrement ( $counter, value, current, duration ) {
        $counter.innerText = --current;
        const delay = duration - (this.options.duration * Math.sin(Math.pow(( current - value ) / current, 3)) );
        duration = duration - delay;

        setTimeout( () => {
            if ( current > value ) {
                this.decrement( $counter, value, current, duration )
            }
        }, delay )
    }

    load(entries, instance) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const $counter = entry.target;
                const start = parseInt(( $counter.dataset.start ) ? $counter.dataset.start : 0);
                const value = parseInt($counter.dataset.value);
                $counter.innerText = start;

                if ( start < value ) {
                    this.increment( $counter, value, start, this.options.duration )
                } else {
                    this.decrement( $counter, value, start, this.options.duration )
                }
                instance.counterObserver.unobserve($counter);
            }
        });
    }
}
